export const NO_PAST_DATES = 'Cannot Search for past dates.';

export const NoResults = 'NoResults';

export interface ErrorHandle {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any | null;
  status: boolean;
  uiError: string | null;
}

export enum ResultsErrorTypes {
  ModelState = 'ModelState',
  Message = 'Message',
  message = 'message',
  code = 'code',
  isTrusted = 'isTrusted'
}

export enum NoResultsTypes {
  NoResultsSearch = 'NO_RESULTS',
  PastDates = 'NO_PAST',
  Error = 'ERROR',
  Empty = 'EMPTY',
  noresults = 'noresults',
  noresults_package = 'ErrorPackageHotelResults'
}

export enum InvalidIdType {
  InvalidValidateOptionId = 'InvalidValidateOptionId',
  invalidsearchid = 'invalidsearchid',
  invalidtoken = 'invalidtoken',
  invalidsearchidoroptionid = 'invalidsearchidoroptionid',
  InvalidExternalToken = 'InvalidExternalToken'
}
